import { DataBean } from "../DataBean";

export class TransportGuideProduct extends DataBean {



    public async deleteTransportGuideProduct(transportGuideDate: any, idTransportGuideProduct: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteTransportGuideProduct_java.util.Date_Number", [transportGuideDate, idTransportGuideProduct]);
    }

    public async getTransportGuideProductCatalog(idTransportGuide: any, transportGuideDate: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getTransportGuideProductCatalog_Number_java.util.Date_Number_Number", [idTransportGuide, transportGuideDate, page, recordsPerPage]);
    }

}